import type { LiteralUnion } from 'type-fest'
import { usePreferredDark } from '@vueuse/core'
import { useCookies } from '@vueuse/integrations/useCookies'

const cookies = useCookies([''])

export const getThemeCookie = <T>(key: string, defaultValue: T) => {
  return cookies.get(`theme-config-${key}`) as T | undefined || defaultValue
}

export const setThemeCookie = (key: string, value: string): void => {
  cookies.set(`theme-config-${key}`, value, {
    path: '/',
  })
}

export const resolveVuetifyTheme = (defaultTheme: LiteralUnion<'light' | 'dark' | 'system', string>): 'light' | 'dark' => {
  const cookieColorScheme = getThemeCookie<'light' | 'dark'>('color-scheme', usePreferredDark().value ? 'dark' : 'light')
  const storedTheme = getThemeCookie('theme', defaultTheme)

  return storedTheme === 'system'
    ? cookieColorScheme === 'dark'
      ? 'dark'
      : 'light'
    : storedTheme as 'light' | 'dark'
}
